/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage', [
        ]);
})();